import { ICommonSettings, IPushNotificationSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigAppleSignIn } from "./app-settings-config-apple-sign-in";

export interface IConfigAppleSignInInputState {
  showModal: boolean;
  editingAppleSigninId: string;
}

export interface IConfigAppleSignInInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigAppleSignInInput extends PureComponent<IConfigAppleSignInInputProps, IConfigAppleSignInInputState> {
  formInputName = ["iosConfig", "appleSigninSettingsId"];

  constructor(props: IConfigAppleSignInInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingAppleSigninId: ""
    };
  }

  openModal = () => {
    this.setState({ editingAppleSigninId: "", showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingAppleSignIn = (id: string) => {
    this.setState({ editingAppleSigninId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as IPushNotificationSetting,
      ...(commonSettings.appleSignInSettings || [])
    ];
    return (
      <>
        <ConfigAppleSignIn
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingAppleSignInId={this.state.editingAppleSigninId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="ios_applesigninsettings_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingAppleSignIn}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appleSignInConfigDropdown"
          addNewTestId="appleSignInSettingsAddNewButton"
          editTestId="appleSignInSettingEditButton"
        />
      </>
    );
  }
}
